import { storageService } from "src/services/api";

const state = {
  status: {},
  errors: [],
  statusText: "",
  data: [],
  metaData: {},
  dataParam: {
    status: "",
    keyword: "",
    page: "",
    tags: [],
    limit: 50,
  },
  single: {},
  vaultFileBlob: "",
  vaultFileImage: "",

  tableFilter: {
    SearchTerm: null,
    clientId: null,
    tags: null,
    isTimeClockRunning: null,
    hideCompleted: null,
    status: null,
  },
  loadingTable: false,
};

const defaultFilter = {
  SearchTerm: null,
  clientId: null,
  tags: null,
  isTimeClockRunning: null,
  hideCompleted: null,
  status: null,
};

const actions = {
  async applyTableFilter({ commit, dispatch }, params) {
    commit("setTableFilter", {
      ...defaultFilter,
      ...params,
    });
    dispatch("getAll", params);
  },

  async clearTableFilter({ commit }) {
    commit("setTableFilter", {
      SearchTerm: null,
      clientId: null,
      dateStart: null,
      dateEnd: null,
      status: null,
    });
  },

  async clearData({ commit }) {
    commit("setData", []);
  },

  async clearFilter({ commit }) {
    commit("setFilter", {
      keyword: "",
      page: "",
      limit: 50,
    });
  },

  async getAll({ commit, dispatch }, params = {}) {
    commit("setLoadingTable", true);
    await storageService.getAll(params).then(
      (response) => {
        commit("setData", response.data);
        commit("setMetaData", response.metaData);
        commit("setLoadingTable", false);
      },
      (error) => {
        dispatch("alert/error", error, { root: true });
        commit("setLoadingTable", false);
      }
    );
  },

  async search({ commit }, params = { keyword: "", page: "", limit: 50 }) {
    commit("setFilter", params);
  },

  async create({ commit, dispatch }, payload) {
    await storageService.create(payload).then(
      (response) => {
        let formattedResponse = {
          data: response,
          message: "Create successfull",
        };
        commit("setSingle", response);
        commit("createSuccess", formattedResponse);
        dispatch("snackbar/success", `Add task "${response.name}" successful`, {
          root: true,
        });
      },
      (responseError) => {
        commit("createFailure", responseError);
        dispatch("alert/error", responseError, { root: true });
      }
    );
  },

  async upload({ commit, dispatch }, payload) {
    await storageService.upload(payload).then(
      (response) => {
        let formattedResponse = {
          data: response,
          message: "Create successfull",
        };
        commit("setSingle", response);
        commit("createSuccess", formattedResponse);
        dispatch(
          "snackbar/success",
          `Upload new file "${response.name}" successful`,
          {
            root: true,
          }
        );
      },
      (responseError) => {
        commit("createFailure", responseError);
        dispatch("alert/error", responseError, { root: true });
      }
    );
  },

  async downloadVault({ dispatch, commit }, params) {
    try {
      const response = await storageService.downloadVault(params);
      if (response.ok) {
        let blob = await response.blob();
        commit("setVaultFileBlob", blob);
        const reader = new FileReader();
        reader.addEventListener('loadend', () => {
          const dataUrl = reader.result;
          commit("setVaultFileImage", dataUrl);
          let formattedResponse = {
            data: response,
            message: "Vault file downloaded",
          };
          commit("createSuccess", formattedResponse);
        });
        reader.readAsDataURL(blob);
        
      } else {
        dispatch("snackbar/error", `file download error`, {
          root: true,
        });
      } 
    } catch (e) {
      dispatch("snackbar/error", `file download error`, {
        root: true,
      });
    }
  },

  async uploadVault({ commit, dispatch }, payload) {
    await storageService.uploadVault(payload).then(
      (response) => {
        let formattedResponse = {
          data: response,
          message: "Create successful",
        };
        commit("setSingle", response);
        commit("createSuccess", formattedResponse);
        dispatch(
          "snackbar/success",
          `Vault file "${payload.filename}" uploaded`,
          {
            root: true,
          }
        );
      },
      (responseError) => {
        commit("createFailure", responseError);
        dispatch("alert/error", responseError, { root: true });
      }
    )
  },

  async deleteVault({ commit, dispatch }, params) {
    try {
      const response = await storageService.deleteVault(params);
      if (response.ok) {
        commit("setVaultFileBlob", "");
        commit("setVaultFileImage", "");
          let formattedResponse = {
            data: response,
            message: "Vault file deleted",
          };
          commit("createSuccess", formattedResponse);
          dispatch(
          "snackbar/success",
          `Vault file deleted`,
          {
            root: true,
          }
        );
        
      } else {
        dispatch("snackbar/error", `Vault file deletion error`, {
          root: true,
        });
      } 
    } catch (e) {
      dispatch("snackbar/error", `Vault file deletion error`, {
        root: true,
      });
    }
  },

  async clearVault({ commit}) {
    commit("setVaultFileBlob", "");
    commit("setVaultFileImage", "");
    commit("setSingle", {});
  },

  async download({ commit, dispatch }, payload) {
    try {
      commit("setSingle", "test");
      let response = await storageService.download(payload);
      if (response.ok) {
        let text = await response.blob();
        let url = URL.createObjectURL(new Blob([text], { type: payload.type }));
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", payload.name);
        link.click();
      } else {
        dispatch("snackbar/error", `Downloading file ${payload.name} error`, {
          root: true,
        });
      }
    } catch (responseError) {
      dispatch("snackbar/error", `Downloading file ${payload.name} error`, {
        root: true,
      });
    }
  },

  async update({ commit, dispatch }, payload) {
    await storageService.update(payload).then(
      (response) => {
        let formattedResponse = {
          data: response,
          message: "Update successfull",
        };

        commit("updateSuccess", formattedResponse);
        commit("updateData", formattedResponse.data);
        dispatch(
          "snackbar/success",
          `Update file "${payload.name}" successful`,
          { root: true }
        );
      },
      (responseError) => {
        commit("createFailure", responseError);
        dispatch("alert/error", responseError, { root: true });
      }
    );
  },

  async updateStatus({ commit, dispatch }, payload) {
    await storageService.updateStatus(payload).then(
      (response) => {
        let formattedResponse = {
          data: response,
          message: "Update successfull",
        };

        commit("updateSuccess", formattedResponse);
        commit("updateData", formattedResponse.data);
        dispatch(
          "snackbar/success",
          `Update file "${response.name}" successful`,
          { root: true }
        );
      },
      (responseError) => {
        commit("createFailure", responseError);
        dispatch("alert/error", responseError, { root: true });
      }
    );
  },

  async delete({ commit, dispatch }, payload) {
    await storageService.delete(payload).then(
      (response) => {
        commit("deleteSuccess", response);
        // commit("deleteData", response.data);
        dispatch(
          "snackbar/success",
          `Delete file "${payload.name}" successful`,
          { root: true }
        );
      },
      () => {
        dispatch("snackbar/error", `Delete file "${payload.name}" error`, {
          root: true,
        });
      }
    );
  },

  async getById({ commit }, id) {
    await storageService.getById(id).then(
      (response) => {
        commit("setSingle", response);
        // dispatch(
        //   "snackbar/success",
        //   `Add user group "${payload.name}" successful`,
        //   { root: true }
        // );
      },
      (responseError) => {
        commit("createFailure", responseError);
        // dispatch("alert/error", responseError, { root: true });
      }
    );
  },
};

const mutations = {
  setLoadingTable(state, data) {
    state.loadingTable = data;
  },

  setTableFilter(state, data) {
    state.tableFilter = data;
  },

  setData(state, data) {
    state.data = data;
  },

  setMetaData(state, data) {
    state.metaData = data;
  },

  setFilter(state, param) {
    state.dataParam = param;
  },

  setSingle(state, data) {
    state.single = data;
  },

  setVaultFileBlob(state, data) {
    state.vaultFileBlob = data;
  },

  setVaultFileImage(state, data) {
    state.vaultFileImage = data;
  },

  appendData(state, item) {
    state.data.push(item);
  },

  updateData(state, item) {
    const index = state.data.findIndex((data) => data.id === item.id);
    if (index !== -1) state.data.splice(index, 1, item);
  },

  deleteData(state, item) {
    state.data.splice(state.data.indexOf(item.id), 1);
  },

  createSuccess(state, response) {
    state.statusText = "create-ok";
    state.status = {
      error: false,
      message: response.message,
    };
    state.single = response.data;
  },

  deleteSuccess(state, response) {
    state.statusText = "delete-ok";
    state.status = { error: false, message: response.message };
  },

  updateSuccess(state, response) {
    state.statusText = "update-ok";
    state.status = { error: false, message: response.message };
  },

  createFailure(state, response) {
    state.statusText = "create-error";
    state.status = { error: true, message: response.message };
  },
};

const getters = {
  getMetaData(state) {
    return state.metaData;
  },
  getAll(state) {
    let data = state.data;
    return data;
  },
  getType: (state) => (value) => {
    return state.typeOptions.find((type) => type.value == value);
  },
};

export const storage = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
